import React, { useState, useEffect, useRef } from "react";
import Config from "../../utils/config";
import Request from "../../utils/Request";
import CsvDown from "../../components/ExportFiles/CsvDown";
import Pagination from "../../components/common/Pagination";
import { useNavigate } from "react-router-dom";
import { TableWarpper, TabsDetailsWrapper, Text, ButtonSolid, IconView, ButtonOutline } from "../../components/styledConstants";
import { Heading } from "../../components/styledConstants";
import { Wrapper } from "./style";
import IconDate from "../../assets/images/IconDate";
import { getParams } from "../../utils/common";
import FilterBox from "../../components/common/FilterBox";
import { CSVLink, CSVDownload } from "react-csv";
import IconDownload from "../../assets/images/IconDownload";
import { dateConvertWithoutTime } from "../../utils/common";
import { FilterWrapper } from "../Merchants/style";
import { ConfirmModalWrapper } from "../../components/common/UI/ConfirmationModal/style";
import MaterialInput from "../../components/common/UI/MaterialInput";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
const holdStatusOptions = [
  { value: "HOLD", label: "HOLD" },
  { value: "RELEASED", label: "RELEASED" },
];

const holdBalanceFilterForm = [
  {
    name: "userId",
    type: "text",
    placeholder: "User ID",
    value: "",
  },
  {
    name: "virtualAccount",
    type: "text",
    placeholder: "Virtual Account",
    value: "",
  },
  {
    name: "checkNo",
    type: "text",
    placeholder: "Check No",
    value: "",
  },
   {
  name: "status",
  value: "",
  type: "select",
  placeholder: "Status",
  options: holdStatusOptions,
},
];

export default function HoldBalenceReports(){
  const paginationConfig = {
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    numberOfElements: 0,
    totalElements: 0,
  };
  const [allHoldBalanceData, setAllHoldBalanceData] = useState([]);
  
  const [holdBalenceList,setHoldBalenceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const[showModal,setShowModal] = useState(false)
  const [paginationData, setPaginationData] = useState({ ...paginationConfig });
  const [balanceDetails, setBalanceDetails] = useState(null);
    const [isCsvDisabled, setIsCsvDisabled] = useState(false);
    // Inside your component, add/replace:
const [controls, setControls] = useState([...holdBalanceFilterForm]);

// Reset filters
const refreshPage = () => {
   const cleared = holdBalanceFilterForm.map(item => ({ ...item, value: "" }));
  setControls(cleared);
  // setControls([...holdBalanceFilterForm]); // reset to empty
  setPaginationData(prev => ({ ...prev, currentPage: 1 }));
   getHoldBalenceReport();
  getAllHoldBalanceData({});
};

// Handle filter input changes
const FilterChangeHandler = (event, index) => {
  const _controls = [...controls];

  // If it's a normal input
  if (event?.target) {
    _controls[index].value = event.target.value;
  }
  // If it's a select option (react-select / custom select)
  else if (event && event.label !== undefined) {
    _controls[index].value = event; // store full { value, label }
  }
  else {
    _controls[index].value = "";
  }

  setControls(_controls);
};


// Trigger search → reset to page 1
const searchHoldBalance = (e) => {
  e?.preventDefault?.();
   const filterParams = getParams(controls);
  setPaginationData(prev => ({ ...prev, currentPage: 1 }));
    getHoldBalenceReport();
    getAllHoldBalanceData(filterParams);
  // fetch will happen via useEffect
};
    const setCurrentPage = (currentPage) => {
      console.log("currentPage",currentPage)
      // setPaginationData(prevPaginationData => ({
      //   ...prevPaginationData,
      //   currentPage: currentPage
       
      // }));
      setPaginationData({...paginationData,currentPage:currentPage})
    };
  const getAllHoldBalanceData = (filterParams = {}) => {
  const successHandler = (res) => {
    setAllHoldBalanceData(res?.data?.content || []);
  };
  const errorHandler = () => {};

  const api = new Request("", successHandler, errorHandler, false);
  const payload = {
    pagination: {
      pageNo: 1,
      pageSize: 5000, // for CSV
    },
    userId: filterParams.userId || "",
    virtualAccount: filterParams.virtualAccount || "",
    checkNo: filterParams.checkNo || "",
    status: filterParams.status?.value || "",
  };

  api.post(`${Config.apis.admin.HOLD_BALENCE_REPORTS}`, payload);
};

    const viewDetails = (requestJson) => {
        // const successHandler = (res) => {
        //     setLoading(false);
        //     console.log("response", res);
        //     setBalanceDetails(res?.data.content.JSON.parse(requestJson));
            setShowModal(true);
        // };
        // const errorHandler = () => {};
        // const api = new Request("", successHandler, errorHandler, false);
        // const payload= {
        //     pagination: {
        //       pageNo: 1,
        //       pageSize: 10
        //     }
        //   }
     
        //   return api.post(`${Config.apis.admin.HOLD_BALENCE_REPORTS}`,payload);
        setBalanceDetails(JSON.parse(requestJson));
        
    };


   const getHoldBalenceReport = () => {
  setLoading(true);

  // Get current filter values in flat object form
  const filterParams = getParams(controls);

  const payload = {
    pagination: {
      pageNo: paginationData.currentPage,
      pageSize: paginationData.pageSize || 10,
    },
    // Only send fields that have value (backend usually ignores empty strings)
    userId: filterParams.userId || "",
    virtualAccount: filterParams.virtualAccount || "",
    checkNo: filterParams.checkNo || "",
    status: filterParams.status?.value || "",  
  };

  const successHandler = (res) => {
    setLoading(false);
    setHoldBalenceList(res?.data?.content || []);
    
    setPaginationData(prev => ({
      ...prev,
      totalPages: res?.data?.totalPages || 1,
      totalElements: res?.data?.totalElements || 0,
      numberOfElements: res?.data?.numberOfElements || 0,
    }));
  };

  const errorHandler = () => {
    setLoading(false);
  };

  const api = new Request("", successHandler, errorHandler, false);
  api.post(Config.apis.admin.HOLD_BALENCE_REPORTS, payload);
};
    
      console.log("kkkkkkk",balanceDetails);

      useEffect(()=>{
         const filterParams = getParams(controls);
        getHoldBalenceReport();
         getAllHoldBalanceData(filterParams);
      },[paginationData?.currentPage])
       const csvHeaders = [
    { label: "User ID", key: "userId" },
    { label: "Transaction Mode", key: "transactionMode" },
    { label: "Transaction Amount", key: "transactionAmount" },
    { label: "Status", key: "status" },
    { label: "Amount", key: "amount" },
    { label: "Check No", key: "chequeNo" },
    { label: "Date", key: "transactionDate" },
    { label: "Debit/Credit", key: "debitCredit" },
    { label: "Remitter Bank", key: "remitterBank" },
    { label: "Remitter IFSC", key: "remitterIFSC" },
    { label: "Remitter Name", key: "remitterName" },
    { label: "Remitter Account", key: "remitterAccount" },
    { label: "Account Number", key: "accountnumber" },
    { label: "Virtual Account", key: "virtualAccount" },
    { label: "Mnemonic Code", key: "mnemonicCode" },
    { label: "Alert Sequence Number", key: "alertSequenceNo" },
    { label: "User Reference Number", key: "userReferenceNumber" },
    { label: "Transaction Description", key: "transactionDescription" },
  ];

      const csvData = allHoldBalanceData.map((item) => {
  let parsedJson = {};
  try {
    parsedJson = item.requestJson ? JSON.parse(item.requestJson) : {};
  } catch (e) {
    parsedJson = {};
  }
  return {
    userId: item.userId || "",
    transactionMode: item.transactionMode || "",
    transactionAmount: item.transactionAmount || "",
    status: item.status || "",
    amount: parsedJson.amount || "",
    chequeNo: parsedJson.chequeNo || "",
    transactionDate: parsedJson.transactionDate || "",
    debitCredit: parsedJson.debitCredit || "",
    remitterBank: parsedJson.remitterBank || "",
    remitterIFSC: parsedJson.remitterIFSC || "",
    remitterName: parsedJson.remitterName || "",
    remitterAccount: parsedJson.remitterAccount || "",
    accountnumber: parsedJson.accountnumber || "",
    virtualAccount: parsedJson.virtualAccount || "",
    mnemonicCode: parsedJson.mnemonicCode || "",
    alertSequenceNo: parsedJson.alertSequenceNo || "",
    userReferenceNumber: parsedJson.userReferenceNumber || "",
    transactionDescription: parsedJson.transactionDescription || "",
  };
});
const handleReleaseHoldAmount = (uuid) => {
  console.log("triggered with uuid", uuid);
  if (!uuid) return;

  const successHandler = (res) => {
    console.log("Release success", res);
    const nestedMessage = res?.data?.message;
     const toastMessage = nestedMessage ;
    //  const toastMessage = nestedMessage || res?.message || "Hold amount released successfully!";
    toast.success(toastMessage, {
      icon: false, 
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    getHoldBalenceReport();
  };

  const errorHandler = (err) => {
    toast.error(err?.message || "Something went wrong!", {
      position: "top-right",
      autoClose: 3000,
    });
    console.error(err);
  };

  const api = new Request("", successHandler, errorHandler, false);
  return api.post(`${Config.apis.admin.RELEASE_HOLD_BALANCE}/${uuid}`);
};


   const handleCsvClick = () => {
  setIsCsvDisabled(true);
  setTimeout(() => {
    setIsCsvDisabled(false);
  }, 15000); // 15 seconds
};
    
 return(
      <Wrapper >
          <div className="flex flex-center space-between mb10">
          <>
             <Heading size="xxl">Hold Balance Report</Heading>
                    <div className="flex gap10">
                <span
             onClick={isCsvDisabled ? (e) => e.preventDefault() : handleCsvClick}
             role="button"
             tabIndex={0}
             onKeyDown={() => {}}
                   >      
             <CSVLink
               headers={csvHeaders}
               data={csvData}
               filename="HoldBalanceReport.csv"
               className="btn btn-primary"
             >
             <ButtonOutline
               as="span"
               className="flex flex-center"
               primary
               rg
               disabled={isCsvDisabled}
               style={{ pointerEvents: isCsvDisabled ? "none" : "auto", opacity: isCsvDisabled ? 0.6 : 1 }}
             >
               <IconDownload className="mr8" /> CSV
             </ButtonOutline>
             </CSVLink>
             </span>
             </div>
        </>
      </div>   
           <div className="mt20">
        <TabsDetailsWrapper>
        {/* <FilterWrapper>  <FilterBox 
         // filterForm={filterForm} 
         // onFilterChange={onFilterChange} 
          //onFilterSubmit={onFilterSubmit}
          //refreshPage={refreshPage}
          /></FilterWrapper> */}
        <FilterWrapper>
      <FilterBox
        filterForm={controls}
        onFilterChange={FilterChangeHandler}
        onFilterSubmit={searchHoldBalance}
        refreshPage={refreshPage}
        className="transactionfilter" // optional - keep styling
      />
      </FilterWrapper>
       
      <TableWarpper className="mt50">
        <table className="table">
          <thead>
            <tr>
              <th className="text-left">
                <Text size="rg" fw="medium">
                User ID
                  
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Transaction Mode
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
              
                Transaction Amount
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                Status
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                  AMOUNT
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                  CHECK NO
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                  DATE
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                  DEBIT/CREDIT
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                REMITTER BANK
                </Text>
              </th>

              <th className="text-left">
                <Text size="rg" fw="medium">
                REMITTER IFSCE
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                REMITTER NAME
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                REMITTER ACCOUNT
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                ACCOUNT NUMBER
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                VIRTUAL ACCOUNT
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                MNEMONIC CODE
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                ALERT SEQUENCE NUMBER
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                USER REFERENCE NUMBER
                </Text>
              </th>
              <th className="text-left">
                <Text size="rg" fw="medium">
                TRANSACTION DISCRIPTION
                </Text>
              </th>
                <th className="text-left">
                <Text size="rg" fw="medium">
                ACTION
                </Text>
              </th>

            
            </tr>
          </thead>
          <tbody>
            {holdBalenceList.length ? (
              holdBalenceList.map((balence, index) => (
                <tr key={index}>
                  <td>
                    <Text size="xsm" color="color3">
                      {balence?.userId}
                    </Text>
                  </td>
                  <td>
                    <Text size="xsm" color="color3">
                      {balence.transactionMode}
                    </Text>
                  </td>

                  <td>
                    <Text size="xsm" color="color3">
                      {balence?.transactionAmount}
                    </Text>
                  </td>
                  <td>
                    <Text size="xsm" color="color3">
                      {balence?.status}
                    </Text>
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).amount : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).chequeNo : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).transactionDate : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).debitCredit : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).remitterBank : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).remitterIFSC : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).remitterName : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).remitterAccount : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).accountnumber : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).virtualAccount : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).mnemonicCode : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).alertSequenceNo : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).userReferenceNumber : "N/A"}
                  </td>
                  <td className="cursor">
                  {balence?.requestJson ? JSON.parse(balence.requestJson).transactionDescription : "N/A"}
                  </td>
                   <td>
              {balence.status === "HOLD" ? (
                <ButtonSolid className="hold-view-btn"  onClick={() => handleReleaseHoldAmount(balence.uuid)}>
                  Release
                </ButtonSolid>
              ) : (
                <span>Released</span>
              )}
               </td>
                               
                </tr>
              ))
            ) : !loading ? (
              <tr>
                <td colSpan={12} style={{ textAlign: "center" }}>No record found</td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </TableWarpper>

          <div className="mt24 flex flex-center">
          {paginationData.totalPages > 1 && (
          <Pagination
            totalPages={paginationData.totalPages}
            currentPage={paginationData.currentPage}
            getCurrentPageData={(curpage) => {
              setCurrentPage(curpage);
            }}
          />
        )}
          </div>
        </TabsDetailsWrapper>
     </div>
        </Wrapper>     
    )
}

